import { render, staticRenderFns } from "./ArticleImages.vue?vue&type=template&id=7bdec227&scoped=true&"
import script from "./ArticleImages.vue?vue&type=script&lang=js&"
export * from "./ArticleImages.vue?vue&type=script&lang=js&"
import style0 from "./ArticleImages.vue?vue&type=style&index=0&id=7bdec227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdec227",
  null
  
)

export default component.exports